var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e983d36ec9fc18f9d04ba5f83c56b61c.js').default;export default
        Object.assign({}, scope_0 )
    